<template>
  <div style="height: 250px" id="left-echarts-03"></div>
</template>
<script>
import * as echarts from "echarts";
export default {
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {
    var chartDom = document.getElementById("left-echarts-03");
    var myChart = echarts.init(chartDom);
    var option = {
      color: ["#0ce5f7", "#ebba54", "#2dbf9d"],
      tooltip: {
        trigger: "item",
        formatter: "品种：{b}{c}(只)",
        textStyle: {
            fontSize: 18
        }
      },
      legend: {
        data: ["新海蓝-京粉", "京粉", "京粉-海兰灰"],
        textStyle: {
          color: "white",
        },
        right: "10",
        bottom: "10",
        orient: 'vertical'
      },
      series: [
        {
          type: "pie",
          // radius: ["50%", "60%"],
          center: ["45%", "60%"],
          // padAngle: 4,
          label:{
            normal: {
                    show: true,
                    textStyle: {
                        fontSize: 20 // 设置字体大小
                    }
                }
          },
          labelLine: {
            show: true,
            length: 20,
            normal: {
                  length: 40 
                }
          },
          data: [
            { value: 50000, name: "新海蓝-京粉" },
            { value: 142000, name: "京粉" },
            { value: 18000, name: "京粉-海兰灰" },
          ],
        },
      ],
    };


    myChart.setOption(option);
    window.addEventListener("resize", () => {
      myChart.resize();
    });
  },
  methods: {},
};
</script>
<style lang="scss" scoped></style>
